import React, { useEffect } from 'react'

export const optionsShowtt = [
    {
      id:0,
      opt:"Select"
    }
    ,{
      id:1,
      opt:10
    },
    {
      id:2,
      opt:20
    },
    {
      id:3,
      opt:30
    },
  ]

export const optionscumulative=[
    {
        id:1,
        opt:"Yes"
    },
    {
        id:2,
        opt:"No"
    },
]
export const optionsleavetype=[
    {
        id:1,
        opt:"Casual"
    },
    {
        id:2,
        opt:"Emergency"
    },
]

export const optionsexptype = [
    {
        id:1,
        opt:"Rainy Day"
    },
    {
        id:1,
        opt:"Strike"
    }
]
export const purplebuttonw10040 = {
    width:"143px",
    height:"40px"

}
export const purplebutton40 = {
    width:"40px",
    height:"40px"
}
export const purplebutton200 = {
    width:"200px",
    height:"40px",
    margin:"0 auto"
}


export const optionsdayofmonth = [
    {
        id:1,
        opt:"1",
    },
    {
        id:2,
        opt:"2"
    }
]
export const optionsdayofweek = [
    {
        id:1,
        opt:"Saturday",
    },
    {
        id:2,
        opt:"Sunday"
    }
]

export const optionsCity =[
    {
        id:1,
        opt:"Dhaka"
    },
    {
        id:2,
        opt:"Barishal"
    }

]

export const optionsmaritalstatus = [
    {
        id:1,
        opt:"Single"
    },
    {
        id:2,
        opt:"Married"
    }
]

export const optionsdesignation = [
    {
        id:1,
        opt:"Teacher"
    },
    {
        id:2,
        opt:"Other Designation"
    }
]
export const optionspersontype = [
    {
        id:1,
        opt:"Part Timer"
    },
    {
        id:2,
        opt:"Full Timer"
    }
]

export const optionscheckedby= [
    {
        id:1,
        opt:"Ekram Ul Haque"
    },
    {
        id:2,
        opt:"Jasbir Sultana Karim"
    },
    {
        id:3,
        opt:"Imran Ul Haque",
    }

]
export const optionstailor = [
    {
        id:1,
        opt:"Order By"
    },
    {
        id:2,
        opt:"Best Regards"
    }

]
export const optionspublish = [
    {
        id:1,
        opt:"true"
    },
    {
        id:2,
        opt:"false"
    }

]


export const optionsnoticefor = [
    {
        id:1,
        opt:"STUDENT"
    },
    {
        id:2,
        opt:"TEACHER"
    }
]

export const optionsnoticetype = [
    {
        id:1,
        opt:"GENERAL"
    },
    {
        id:2,
        opt:"NEWS"
    }
]

export const optionsevent = [
    {
        id:1,
        opt:"Event 1"
    },
    {
        id:2,
        opt:"Event 2"
    }
]

export const optionsapplicationstatus = [
    {
        id:1,
        opt:"Active"
    },
    {
        id:2,
        opt:"Inactive"
    }
]
export const optionsmarkallow = [
    {
        id:1,
        opt:"true"
    },
    {
        id:2,
        opt:"false"
    }
]

export const optionsnationality = [
    {
        id:1,
        opt:"Banglaseshi"
    },
    {
        id:2,
        opt:"Indian"
    }
]
export const optionsreligion = [
    {
        id:1,
        opt:"Islam"
    },
    {
        id:2,
        opt:"Hinduism"
    }
]

export const optionsbloodgroup = [
    {
        id:1,
        opt:"A+"
    },
    {
        id:2,
        opt:"O+"
    }
]

export const optionsteacherName = [
    {
        id:1,
        opt:"Farhana Akhter"
    },
    {
        id:2,
        opt:"Morshed Alam"
    }
]


export const optionsExam = [
    {
        id:1,
        opt:"1st Semester"
    },
    {
        id:2,
        opt:"2nd Semester"
    }
]

export const optionsremark = [
    {
        id:1,
        opt:"Good"
    },
    {
        id:2,
        opt:"Bad"
    }
]

export const optionsrcvtype = [
    {
        id:1,
        opt:"Cash"
    },
    {
        id:2,
        opt:"Card"
    }
]

export const optionsgender = [
    {
        id:1,
        opt:"Male"
    },
    {
        id:2,
        opt:"Female"
    },
    {
        id:3,
        opt:"Other"
    }
]

export const optionsbilltype = [
    {
        id:1,
        opt:"School"
    },
    {
        id:2,
        opt:"Others"
    },
    {
        id:3,
        opt:"Student Wise"
    },
]

export const optionsThana = [
 
{
    id:1,
    opt:"Adabar Thana"
},
{
    id:2,
    opt:"Badda Thana"
},
{
    id:3,
    opt:"Bangshal Thana"
},
{
    id:4,
    opt:"Bimanbandar Thana"
}
]
export const optionsDistrict = [
    {
        id:1,
        opt:"Dhaka District"
    },
    {
        id:2,
        opt:"Faridpur District"
    },
    {
        id:3,
        opt:"Gazipur District"
    },
    {
        id:4,
        opt:"Gopalganj District"
    }



]

export const optionsDivision = [
    

    {
        id:1,
        opt:"Barisal Division"
    },
    {
        id:2,
        opt:"Chittagong Division"
    },
    {
        id:3,
        opt:"Dhaka Division"
    },
    {
        id:4,
        opt:"Khulna Division"
    },
    {
        id:5,
        opt:"Mymensingh Division"
    },
]

export const optionsCountry=[
    {
        id:1,
        opt:"Bangladesh"
    },
    {
        id:2,
        opt:"China"
    },
    {
        id:3,
        opt:"India"
    },
    {
        id:4,
        opt:"Indonesia"
    },
    {
        id:5,
        opt:"Japan"
    },


]

export const optionsdocumentType=[
    {
        id:1,
        opt:"HOME WORK"
    },
    {
        id:2,
        opt:"CLASS WORK"
    }
]

export const optionsinfotype = [
    {
        id:1,
        opt:"HOME_BODY"
    },
    {
        id:2,
        opt:"HOME_BODY_HEAD"
    }
]

export const optionsDay = [
    {
        id:1,
        opt:"Subday"
    },
    {
        id:1,
        opt:"Monday"
    },
    {
        id:1,
        opt:"Tuesday"
    },
    {
        id:1,
        opt:"Wednesday"
    },
    {
        id:1,
        opt:"Thursday"
    },

]

export const optionsBook = [
    {
        id:0,
        opt:"All Subjects"
    },
    {
        id:1,
        opt:"Mathematics Book"
    },
    {
        id:2,
        opt:"English Book"
    },
    {
        id:3,
        opt:"ICT Book"
    }
]

export const optionsTeacher = [
    {
        id:1,
        opt:"Monjurul Islam"
    },
    {
        id:2,
        opt:"Hosne Ara"
    }
]

export const optionsPeriod2 = [
    {
        id:1,
        opt:"1st"
    },
    {
        id:1,
        opt:"2nd"
    },
    {
        id:1,
        opt:"3rd"
    },
    {
        id:1,
        opt:"4th"
    },
]

export const optionsShift = [
    {
        id:1,
        opt:"Morning Shift"
    },
    {
        id:2,
        opt:"Day Shift"
    }
]

export const optionsSubject = [
    {
        id:0,
        opt:"All Subjects"
    },
    {
        id:1,
        opt:"Mathematics"
    },
    {
        id:2,
        opt:"English"
    },
    {
        id:3,
        opt:"ICT"
    }
]
export const optionsSubGroup = [
    
    {
        id:1,
        opt:"Mathematics-1"
    },
    {
        id:2,
        opt:"Mathematics-2"
    },
    {
        id:3,
        opt:"ICT-1"
    },
    {
        id:3,
        opt:"ICT-2"
    },
]

export const optionsdept=[
    {
        id:0,
        opt:"All Department"
    },
    {
        id:1,
        opt:"IT"
    },
    {
        id:2,
        opt:"Admin & HR"
    }
]

export const optionsCampus = [
    {
        id:0,
        opt:"All Campus"
    },
    {
        id:1,
        opt:"Campus 1"
    },
    {
        id:2,
        opt:"Campus 2"
    },
    {
        id:3,
        opt:"Campus 3"
    },
]

export const optionsPeriod = [
    {
        id:0,
        opt:"All Period"
    },
    {
        id:1,
        opt:"April-23"
    },
    {
        id:2,
        opt:"May-23"
    },
    {
        id:3,
        opt:"June-23"
    },
]

export const roledrp = [
    {
        id:0,
        opt:"Select"
    },
    {
        id:1,
        opt:"Admin"
    },
    {
        id:2,
        opt:"Admin Academic"
    }
]

export const optionsStatusAI = [
    {
        id:1,
        opt:"Active"
    },
    {
        id:2,
        opt:"Inactive"
    },
]

export const optionsStatus = [
    {
        id:1,
        opt:"All"
    },
    {
        id:2,
        opt:"Promoted"
    },
    {
        id:3,
        opt:"Not Promoted"
    }
]

export const optionspromotion = [
  {
      id:1,
      opt:'All'
  },
  {
      id:2,
      opt:'Promoted'
  },
  {
      id:3,
      opt:'Not Promoted'
  },
];

export const optionsqualification = [
  {
      id:1,
      opt:'SSC'
  },
  {
      id:2,
      opt:'HSC'
  }
];
export const optionssession = [
  {
      id:1,
      opt:'July 2022 - June 2023'
  },
  {
      id:2,
      opt:'July 2023 - June 2024'
  }
];
export const optionssection = [
  {
    id:1,
    opt:"Diamond 1"
  },
  {
    id:2,
    opt:"Diamond 2"
  },
  {
    id:3,
    opt:"Ruby 1"
  },
  {
    id:4,
    opt:"Ruby 2"
  },
]
export const optionssemester = [
  {
      id:1,
      opt:'First Semester'
  },
  {
      id:2,
      opt:'Second Semester'
  }
];
export const optionsClass = [
  {   id:0,
      opt:'Select Class'
  },
  {   id:1,
      opt:'Starter'
  },
  {   id:2,
      opt:'Playgroup'
  },
  {   id:3,
      opt:'Nursery'
  },
  {   id:4,
      opt:'Junior KG'
  },
  {   id:5,
      opt:'Senior KG'
  },
  {   id:6,
      opt:'Class 1'
  },
  {   id:7,
      opt:'Class 2'
  },
  {   id:8,
      opt:'Class 3'
  },
  {
      id:9,
      opt:'Class 4'
  },
  {
      id:10,
      opt:'Class 5'
  },
  {
      id:11,
      opt:'Class 6'
  },
  {
      id:12,
      opt:'Class 7'
  },
  {
      id:13,
      opt:'O Level'
  },
  {
      id:14,
      opt:'A Level'
  },
  {
      id:15,
      opt:'Pre- O level'
  },

];

const Helper = () => {

    

  return (
    <></>
  )
}



export default Helper